import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from "react";

interface AuthContextType {
  isLoggingOut: boolean;
  setIsLoggingOut: (value: boolean) => void;
}

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const value = useMemo(
    () => ({ isLoggingOut, setIsLoggingOut }),
    [isLoggingOut]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const AuthContext = createContext<AuthContextType>({
  isLoggingOut: false,
  setIsLoggingOut: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
